import "../../styles/screens/homeSection.scss";
import React, { useState } from "react";
import MobileNav from "../atoms/mobileNav";
import Logo from "../atoms/logo";
import { Link } from "react-router-dom";
import de from "../../assets/texts/de.json";
import sr from "../../assets/texts/sr.json";
import { useLanguage } from "../../i18n/LanguageContext";

const Navbar = () => {
  const [showDropdown, setShowDropdown] = useState(false);

  const toggleDropdown = () => {
    setShowDropdown(!showDropdown);
  };

  const handleServiceClick = () => {
    setShowDropdown(false);
  };

  const handleNavLinkClick = (event) => {
    const href = event.currentTarget.getAttribute('href'); // Get the href attribute
    if (href.startsWith('#')) {
      event.preventDefault(); // Prevent the default anchor behavior
      window.location.hash = href; // Set the hash manually
      // No need to manually scroll here, as your useScrollToSection hook should handle it
    }
  };

  const { language, setLanguage } = useLanguage();
  const t = language === "sr" ? sr : de;

  const toggleLanguage = () => setLanguage(language === "sr" ? "de" : "sr");

  return (
    <div id="nav-container">
      <MobileNav />

      <div className="sidebar">
        <Logo />
        {/* <a href="/#home" className="menu-item" onClick={handleNavLinkClick}>
          Startseite
        </a> */}
        <Link to="/#home" className="menu-item">
          {t.nav.home}
        </Link>
        <div
          className={`menu-item ${showDropdown ? "dropdown" : ""}`}
          onMouseEnter={toggleDropdown}
          onMouseLeave={toggleDropdown}
        >
          {t.nav.services}
          {showDropdown && (
            <div className="dropdown-content">
              <Link to="/serviceFirst" onClick={handleServiceClick}>
                {t.services.service[0].name}
              </Link>
              <Link to="/serviceSecond" onClick={handleServiceClick}>
                {t.services.service[1].name}
              </Link>
              <Link to="/serviceThird" onClick={handleServiceClick}>
                {t.services.service[2].name}
              </Link>
              <Link to="/serviceFourth" onClick={handleServiceClick}>
                {t.services.service[3].name}
              </Link>
            </div>
          )}
        </div>
        <a href="/#about" className="menu-item" onClick={handleNavLinkClick}>
          {t.nav.about}
        </a>
        <a href="/#contact" className="menu-item" onClick={handleNavLinkClick}>
          {t.nav.contact}
        </a>
        <button onClick={toggleLanguage} className="menu-item lang-btn" title={language === "sr" ? "Deutsch" : "Srpski"}>
          {language === "sr" ? (
            <span className="flag flag-de"><span></span><span></span><span></span></span>
          ) : (
            <span className="flag flag-rs"><span></span><span></span><span></span></span>
          )}
        </button>
      </div>
    </div>
  );
};

export default Navbar;
